import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Plus, Trash2, ClipboardList, Pencil } from "lucide-react";

export default function CoachJornadas() {
  const [jornadas, setJornadas] = useState([]);
  const [teams, setTeams] = useState([]);

  const load = async () => {
    try {
      const [j, t] = await Promise.all([api.get("/jornadas"), api.get("/teams")]);
      setJornadas(j.data);
      setTeams(t.data);
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  useEffect(() => { load(); }, []);

  const teamName = (id) => teams.find(t => t.id === id)?.name || "—";

  const remove = async (id) => {
    if (!window.confirm("¿Eliminar esta jornada?")) return;
    try {
      await api.delete(`/jornadas/${id}`);
      toast.success("Jornada eliminada");
      load();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  return (
    <div>
      <div className="flex items-start justify-between mb-8">
        <div>
          <div className="overline">Registro semanal</div>
          <h1 className="font-heading font-black text-5xl tracking-tighter uppercase mt-2">Jornadas</h1>
          <p className="text-muted-foreground text-sm mt-2">Partidos y entrenamientos registrados.</p>
        </div>
        <Link to="/coach/jornadas/new" data-testid="new-jornada-btn" className="btn-volt">
          <Plus size={16} /> Nueva jornada
        </Link>
      </div>

      <div className="border border-border">
        <table className="w-full text-sm">
          <thead className="border-b border-border">
            <tr className="text-left overline">
              <th className="p-3">Fecha</th>
              <th className="p-3">Tipo</th>
              <th className="p-3">Equipo</th>
              <th className="p-3">Rival</th>
              <th className="p-3">Resultado</th>
              <th className="p-3 w-24"></th>
            </tr>
          </thead>
          <tbody>
            {jornadas.map((j) => (
              <tr key={j.id} data-testid={`j-row-${j.id}`} className="border-b border-border/60 hover:bg-white/[0.02]">
                <td className="p-3 font-mono text-xs">
                  {j.date}
                  {j.status === "draft" && (
                    <span data-testid={`j-draft-badge-${j.id}`} className="ml-2 px-1.5 py-0.5 border border-primary bg-primary/10 text-primary text-[9px] font-heading tracking-widest animate-pulse">BORRADOR</span>
                  )}
                </td>
                <td className="p-3">
                  <span className={`px-2 py-1 border font-mono text-[10px] uppercase ${j.session_type === 'partido' ? 'border-primary text-primary' : 'border-border'}`}>
                    {j.session_type}
                  </span>
                </td>
                <td className="p-3 font-heading font-bold uppercase">{teamName(j.team_id)}</td>
                <td className="p-3">
                  {j.session_type === 'partido' ? (
                    <span>J{j.jornada_number} · {j.opponent || "—"} <span className="text-muted-foreground text-xs">({j.home_away})</span></span>
                  ) : (
                    <span className="text-muted-foreground">—</span>
                  )}
                </td>
                <td className="p-3 font-heading">
                  {j.session_type === 'partido' && j.team_stats ? (
                    <span className={`metric-number text-lg ${j.team_stats.resultado === 'V' ? 'text-primary' : j.team_stats.resultado === 'D' ? 'text-destructive' : ''}`}>
                      {j.team_stats.gols_favor}-{j.team_stats.gols_contra}
                    </span>
                  ) : "—"}
                </td>
                <td className="p-3 text-right">
                  <div className="flex justify-end gap-2">
                    <Link to={`/coach/jornadas/new?edit=${j.id}`} data-testid={`edit-j-${j.id}`} className="text-muted-foreground hover:text-primary"><Pencil size={14} /></Link>
                    <button data-testid={`del-j-${j.id}`} onClick={() => remove(j.id)} className="text-muted-foreground hover:text-destructive"><Trash2 size={14} /></button>
                  </div>
                </td>
              </tr>
            ))}
            {jornadas.length === 0 && (
              <tr><td colSpan={6} className="text-center p-12"><ClipboardList className="mx-auto text-muted-foreground" size={28} /><div className="mt-3 text-muted-foreground text-sm">Sin jornadas registradas. Crea tu primera jornada.</div></td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
